<template>
    <DataTable :value="productList" responsiveLayout="scroll">
        <Column field="name" header="Найменування" width="123px"></Column>
        <Column field="vendorName" header="Виробник"></Column>
        <Column field="count" header="Кількість"></Column>
        <Column field="measure" header="Од.вим.">
            <template #body="slotProps">
                шт.
            </template>
        </Column>
        <Column field="measure" header="Ціна, грн. без ПДВ">
            <template #body="slotProps">
                            <span class="single-line">
                                {{ slotProps.data.priceNoNds.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") }}
                            </span>
            </template>
        </Column>
        <Column field="measure" header="Сума, грн. без ПДВ">
            <template #body="slotProps">
                            <span class="single-line">
                                {{ (slotProps.data.priceNoNds * slotProps.data.count).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") }}
                            </span>
            </template>
        </Column>
        <Column field="measure" header="Посилання на тех. хар.">
            <template #body="slotProps">
                <a :href="slotProps.data.link" target="_blank">
                    <Button
                        icon="pi pi-info-circle"
                        class="p-button-text"
                    />
                </a>
            </template>
        </Column>
        <ColumnGroup type="footer">
            <Row>
                <Column :colspan="4" />
                <Column footer="Сума без ПДВ" />
                <Column :colspan="2">
                    <template #footer>
                                    <span class="single-line">
                                        {{ calculateCommonSumNoNds().toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') }}
                                    </span>
                    </template>
                </Column>
            </Row>
            <Row>
                <Column :colspan="4" />
                <Column footer="ПДВ" />
                <Column :colspan="2">
                    <template #footer>
                                    <span class="single-line">
                                        {{ calculateNds() }}
                                    </span>
                    </template>
                </Column>
            </Row>
            <Row>
                <Column :colspan="4" />
                <Column footer="Сума з ПДВ" />
                <Column :colspan="2" >
                    <template #footer>
                                        <span class="single-line">
                                            {{ calculateSumWithNds() }}
                                        </span>
                    </template>
                </Column>
            </Row>
        </ColumnGroup>
    </DataTable>
</template>

<script>
import DataTable from "primevue/datatable";
import Row from "primevue/row";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";

export default {
    name: "KrmOrderList",
    components: {
        DataTable,
        Row,
        Column,
        ColumnGroup,
        Button,
    },
    props: {
        productList: {
            required: true,
            type: [Array],
            default: []
        },
    },
    methods: {
        calculateCommonSumWithNds() {
            let sum = 0;
            Object.keys(this.productList).forEach(key => {
                sum += this.productList[key]['price'] * this.productList[key]['count']
            });

            return sum;
        },
        calculateCommonSumNoNds() {
            let sum = 0;
            Object.keys(this.productList).forEach(key => {
                sum += this.productList[key]['priceNoNds'] * this.productList[key]['count']
            });

            return sum;
        },
        calculateNds() {
            return (this.calculateCommonSumWithNds() - this.calculateCommonSumNoNds()).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        calculateSumWithNds() {
            return this.calculateCommonSumWithNds().toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
    },
}
</script>

